import React from "react"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"

const BlogPost = ({ data }) => {
  if (data === undefined)
    return (
      <Layout>
        <div>
          <p>Build error</p>
        </div>
      </Layout>
    )
  const { frontmatter, body } = data.mdx
  const image = getImage(frontmatter.cover)
  return (
    <Layout>
      <div>
        <GatsbyImage image={image} alt="coverImage" />
        <MDXRenderer>{body}</MDXRenderer>
      </div>
    </Layout>
  )
}

export default BlogPost
export const query = graphql`
  query PostsBySlug($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        title
        date(formatString: "YYYY MMMM Do")
        coverCredit
        cover {
          childImageSharp {
            gatsbyImageData(aspectRatio: 3)
          }
          publicURL
        }
      }
    }
  }
`
